var Language = {
  ENG_US : "1033",
  SP_MX : "2058",
  FR : "1036",
  NONE : "1024",
  PT_BR: "1046"
};

module.exports = Language;


// WEBPACK FOOTER //
// ./src/componentes/lib/rtf/language.js